<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'

import Intro from './views/Intro'
import CardGame from '@/views/CardGame'
import Outro from '@/views/Outro'
import SaisieAbsenceGame from '@/views/SaisieAbsenceGame'
import scrollHelper from '@shared/utils/scrollHelper'
import EndOutro from '@/views/EndOutro'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    cardGame: CardGame,
    outro: Outro,
    saisieGta: SaisieAbsenceGame,
    endOutro: EndOutro
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
@import "../shared/styles/globals";
</style>
